import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  height: 100%;
  overflow-x: auto;
`;

export const Form = styled.form`
  width: 100%;
  min-width: 250px;
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  & > * {
    margin-bottom: 10px;
  }
  & > div {
    height: 100%;
    margin-top: 20px;
  }
`;

export const List = styled.div`
  & > h3 {
    font-size: 20px;
    text-align: center;
  }
`;
